import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
import qs from 'qs';
import VueClipboard from 'vue-clipboard2'

Vue.prototype.$axios = axios
Vue.use(VueClipboard)

axios.defaults.baseURL = 'https://dyp.ylhwlkj.com/api/';
// axios.defaults.baseURL = 'https://xcx.ylhwlkj.com/api/';
axios.interceptors.request.use(function (config) {
let user=''
let user_id=''
let token=''


    // eslint-disable-next-line no-prototype-builtins
 if(window.localStorage.getItem('user')!= "undefined"&&window.localStorage.hasOwnProperty('user')){
   user = JSON.parse(window.localStorage.getItem('user'));

   user_id = user.userid
  token = user.token

 }

    if(config.method === 'post') {
        let data = qs.parse(config.data)

        config.data = qs.stringify({
            token:token,
			...data
        })
    } else if(config.method === 'get') {
        config.params = {
            token:token,
			...config.params
        }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  })




Vue.use(Vant);

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
